import { IconButton, Stack } from '@mui/material';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

export default function ArticleEditorToolbar({ editor, isMobile }) {

  const renderButton = (icon, onClick, active) => (
    <IconButton
      size="small"
      sx={{ '& svg': { fontSize: '16px' } }}
      onClick={onClick}
      color={active ? 'primary' : 'default'}
    >
      {icon}
    </IconButton>
  );

  return (
    <Stack
      direction={isMobile ? 'row' : 'row'}
      spacing={1}
      sx={{
        mb: 1,
        flexWrap: isMobile ? 'wrap' : 'nowrap'
      }}
    >
      {renderButton(
        <FormatBoldIcon />,
        () => editor?.chain().focus().toggleBold().run(),
        editor?.isActive('bold')
      )}
      {renderButton(
        <FormatItalicIcon />,
        () => editor?.chain().focus().toggleItalic().run(),
        editor?.isActive('italic')
      )}
      {renderButton(
        <FormatListBulletedIcon />,
        () => editor?.chain().focus().toggleBulletList().run(),
        editor?.isActive('bulletList')
      )}
      {renderButton(
        <FormatListNumberedIcon />,
        () => editor?.chain().focus().toggleOrderedList().run(),
        editor?.isActive('orderedList')
      )}
      {renderButton(
        <FormatQuoteIcon />,
        () => editor?.chain().focus().toggleBlockquote().run(),
        editor?.isActive('blockquote')
      )}
    </Stack>
  );
}
